import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.close_dialog = function () {
  Stimulus.controllers.find(c => c.identifier == "dialog").close()
}
